<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import type { DialogEvents } from "@/components/mixins/dialogs";
import { useReactiveDialogScriptSetup } from "@/components/mixins/dialogs";
import UnauthorisedComponent from "@/components/pages/UnauthorisedComponent.vue";
import { EnumDialogType } from "@/components/dialogs/DialogTypes";
import type { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import type { ReadonlyEntityArray } from "@/components/composables/reactivityTypes";

export interface UnauthorisedDialogProps {
  requiredPermissions: ReadonlyEntityArray<EnumUserPermission>;
}
export interface UnauthorisedDialogEvents extends DialogEvents {}

defineProps<UnauthorisedDialogProps>();
const emit = defineEmits<UnauthorisedDialogEvents>();

const { accept, cancel } = useReactiveDialogScriptSetup(emit);
</script>

<template>
  <bm-dialog
    :label="$m.unauthorised"
    :dialog-type="EnumDialogType.none"
    :cancelable="false"
    width="1200"
    @accept="accept"
    @cancel="cancel"
  >
    <v-container fluid pa-0>
      <v-row>
        <v-col cols="12">
          <unauthorised-component :required-permissions="requiredPermissions" />
        </v-col>
      </v-row>
    </v-container>
    <template #controls-confirm-text>
      {{ $m.ok }}
    </template>
  </bm-dialog>
</template>
